<app-header></app-header>

<div class="container" style="height: auto; margin: 3rem auto">
  <div class="px-2 py-2 my-2">
    <h1 class="mb-3 text-heading">Forgot your password</h1>
    <p class="h6 text-center mb-5" style="font-size: 16px; color: #000000">
      Enter your email below to receive your reset password instruction.
    </p>
    <div class="col-lg-6 mx-auto">
      <form
        [formGroup]="forgotPasswordForm"
        #ngForm
        (keydown.enter)="resetPassword()"
      >
        <mat-form-field [style.width.%]="100" appearance="outline" class="mt-2">
          <mat-label>Email</mat-label>
          <input
            matInput
            placeholder="juandelacruz@gmail.com"
            formControlName="email"
          />
        </mat-form-field>
        <mat-error
          *ngIf="
            forgotPasswordForm.get('email').invalid &&
            (forgotPasswordForm.get('email').dirty ||
              forgotPasswordForm.get('email').touched)
          "
          class="mb-4"
        >
          Provide a valid email (e.g: juandelacruz@gmail.com)
        </mat-error>
        <button
          mat-raised-button
          color="primary"
          class="text-white mb-3"
          [style.width.%]="100"
          type="button"
          [disabled]="isDisabled"
          (click)="resetPassword()"
        >
          Submit
        </button>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

        <p class="mt-3 text-center"><a href="/login">Go back to sign in</a></p>
      </form>
    </div>
  </div>
</div>

<app-footer></app-footer>
